import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: '',
    created: null,
    violations: null
  },
  getters: {
    created: (state) => state.created,
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    violations: (state) => state.violations
  },
  mutations: {
    reset (state) {
      state.created = null
      state.error = ''
      state.isLoading = false
      state.violations = null
    },
    setError (state, payload) {
      state.error = payload
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setCreated (state, payload) {
      state.created = payload
    },
    setViolations (state, payload) {
      state.violations = payload
    }
  },
  actions: {
    async create ({ commit }, values) {
      commit('toggleLoading')
      const response = await new ApiService('e_x_c_m_tasks').post(values)
      commit('setCreated', await response.json())
      commit('toggleLoading')
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
